import PersonaPage from "./PersonaPage";

const questions = [
  { q: "Wer war er für Sie?", why: "Vater, Bruder, Sohn, Ehemann, Freund — die Beziehung bestimmt den Ton der Rede." },
  { q: "Wie war seine Art?", why: "Ruhig oder herzhaft, humorvoll oder wortkarg — daraus formt sich seine Stimme im Text." },
  { q: "Was war ihm wichtig?", why: "Familie, Arbeit, ein Handwerk, ein Verein — die Achsen seines Lebens werden zu Achsen der Rede." },
  { q: "Eine Erinnerung, die bleibt.", why: "Ein Satz, ein Werkzeug, ein Sonntagsritual — das konkrete Detail trägt eine Rede." },
  { q: "Was hat er hinterlassen?", why: "Nicht nur Dinge — Haltungen, Sätze, eine Art zu lachen. Das ist der Kern jeder Würdigung." },
  { q: "Wie soll die Rede klingen?", why: "Getragen, warm oder mit einem stillen Lächeln. Sie geben den Ton, wir hören zu." },
  { q: "Wen sprechen Sie an?", why: "Nahe Familie, ein weiter Freundeskreis, Kolleginnen und Kollegen — der Kreis prägt die Sprache." },
  { q: "Wie lang darf sie sein?", why: "Ein Wort mehr ist manchmal ein Wort zu viel. Sie wählen die Länge, die trägt." },
];

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für den Vater?",
    a: "Beginnen Sie nicht mit dem Datum, sondern mit einer Geste — ein Werkzeug in seinen Händen, ein Satz, den er oft sagte. Von dort aus öffnet sich die Rede von selbst. Unser Fragebogen führt Sie in acht ruhigen Schritten dorthin.",
  },
  {
    q: "Was, wenn wir kein enges Verhältnis hatten?",
    a: "Ehrlichkeit trägt weiter als Pathos. Eine Trauerrede darf auch Distanz benennen — sie muss nur einen Punkt finden, an dem Respekt und Erinnerung zusammenfallen. Wir helfen, diesen Punkt behutsam zu formulieren.",
  },
  {
    q: "Wie viel Humor darf in einer Trauerrede für einen Mann sein?",
    a: "So viel, wie zu ihm gepasst hätte. Ein leises Lachen an der richtigen Stelle ist keine Respektlosigkeit — es ist Erinnerung. Sie entscheiden über den Ton, wir setzen ihn behutsam um.",
  },
  {
    q: "Können wir die Rede noch anpassen?",
    a: "Selbstverständlich. Der Entwurf ist ein Ausgangspunkt in Ihrer Stimme — Sie kürzen, ergänzen, verändern, bis er sich richtig anfühlt.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für eine Frau", to: "/trauerrede-frau" },
  { label: "Trauerrede für den Ehepartner", to: "/trauerrede-ehepartner" },
];

export default function TrauerredeMann() {
  return (
    <PersonaPage
      slug="trauerrede-mann"
      metaTitle="Trauerrede für einen Mann schreiben — Vater, Bruder, Sohn | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für einen Vater, Bruder, Sohn oder Ehemann. Aus acht behutsamen Fragen entsteht ein würdevoller Entwurf — sofort verfügbar. Ab 29 €."
      eyebrow="Trauerrede · Vater · Bruder · Sohn · Ehemann"
      headline={
        <>
          Eine Trauerrede für ihn.
          <br />
          <span className="italic text-umber">In der Stimme, die er verdient hatte.</span>
        </>
      }
      intro="Für den Vater, der wenig sprach, aber viel bedeutete. Für den Bruder, der einem den Rücken stärkte. Für den Sohn, dessen Weg zu kurz war. Ein behutsamer erster Entwurf, aus dem Ihre Worte wachsen — nicht die eines Fremden."
      heroImage="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80"
      heroImageAlt="Ein Paar Männerhände hält einen alten Brief im warmen Nachmittagslicht — Sinnbild einer stillen Trauerrede für einen Vater"
      questions={questions}
      exampleQuote={
        <>
          „Er war kein Mann der großen Worte. Er war einer, der um sechs aufstand, den Kaffee aufsetzte
          und leise die Tür hinter sich schloss, damit niemand aufwachte. Wer ihn kannte, kannte diese
          kleine Geste — und wer sie erlebte, wusste: Da sorgt jemand. Ohne Aufhebens. Ein Leben lang.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
